const header = document.querySelector('.header');
window.onscroll = () => {
    if (window.scrollY > 180) {
        header.classList.add('sticky-header');
        document.body.classList.add('body-sticky'); // Remove sticky class
    } else {
        header.classList.remove('sticky-header');
        document.body.classList.remove('body-sticky'); // Remove sticky class
    }
};

// menu data

const menuContainer = document.querySelector('.menu-icons');
const navigationContainer = document.querySelector('.navigation-container');

let openMenu = true;
menuContainer.addEventListener('click', () => {
    menuContainer.classList.toggle('change');
    if (openMenu) {
        navigationContainer.style.display = 'block';
        openMenu = false;
    } else {
        navigationContainer.style.display = 'none';
        openMenu = true;
    }
});
